import type { Problem } from "../types";

export function pickProblem(tables: number[], previous?: Problem): Problem {
  const a = tables[Math.floor(Math.random() * tables.length)] ?? 2;
  let b = 2 + Math.floor(Math.random() * 9);

  if (previous && previous.a === a && previous.b === b) {
    b = b === 10 ? 2 : b + 1;
  }

  return Math.random() > 0.5 ? { a, b } : { a: b, b: a };
}

export function getResult(problem: Problem): number {
  return problem.a * problem.b;
}
